export const STATUS_DONE = 'Done'
export const STATUS_NOT_STARTED = 'Not Started'
/** Em dash — used when lesson-instructor role is not set */
export const STATUS_NA = '\u2014'

/**
 * DWB report: show Done / Not Started from API counts when the site enables that
 * program. Per-user lesson-instructor preferences are not used (unlike K–8 core).
 */
export function dwbTrainingCompletionStatus(count, total) {
  const n = count === undefined || count === null ? 0 : count
  if (n >= total) {
    return STATUS_DONE
  }
  return STATUS_NOT_STARTED
}

/**
 * K–8 core report: `n/total` fraction, or em dash when the user has no
 * lesson-instructor preference set (`teachesLessons` undefined).
 */
export function coreCompletionFraction(count, total, teachesLessonsDefined) {
  if (!teachesLessonsDefined) {
    return STATUS_NA
  }
  const n = count === undefined || count === null ? 0 : count
  return `${n}/${total}`
}
